import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string; disabled?: boolean }>`
  background: ${(p) => p.color || "#2e186a"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 13px 0;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};  /* Reduce opacity when disabled */

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid rgb(255, 130, 92);
    background-color: rgb(255, 130, 92);

    /* Only allow hover, active, and focus styles if the button is not disabled */
    ${(p) => p.disabled && `
      background-color: #2e186a;  /* Keep default background when disabled */
      border: 1px solid #edf3f5;  /* Keep default border when disabled */
    `}
  }

  /* Additional styles for when the button is disabled */
  &:disabled {
    cursor: not-allowed;
    background: ${(p) => p.color || "#2e186a"};
    border: 1px solid #edf3f5;
    opacity: 0.5;  /* Make button more transparent */
  }
`;
